import ApiService from "../../utils/ApiService";

export const orderDelete = async (orderId, token) => {
  try {
    const res = await ApiService.DELETE_ORDER(orderId, token);

    return {
      success: res.code === 200,
      msg: res.code === 200 ? "Order deleted successfully." : res.message,
    };
  } catch (error) {
    return {
      success: false,
      msg: "Faild to delete order",
    };
  }
};
